import { render, staticRenderFns } from "./Resultados.vue?vue&type=template&id=cdb0aaec&scoped=true&"
import script from "./Resultados.vue?vue&type=script&lang=js&"
export * from "./Resultados.vue?vue&type=script&lang=js&"
import style0 from "./Resultados.vue?vue&type=style&index=0&id=cdb0aaec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb0aaec",
  null
  
)

export default component.exports